/**
 * Removes what we are not going to use from a contacts export, in the browser,
 * before anything is uploaded.
 *
 * The server would ignore these properties anyway — so this is not about
 * correctness. It is that a contacts export contains the home address and
 * birthday of everyone in someone's phone, and stripping them on the device
 * means they never leave it. Ten lines for a materially better privacy story.
 *
 * It also removes the PHOTO blobs, which are most of the size of a .vcf.
 */

/** Dropped: unused by the importer, and none of our business. */
const DROP = new Set([
  'PHOTO',
  'LOGO',
  'SOUND',
  'KEY',
  'ADR',
  'BDAY',
  'ANNIVERSARY',
  'GEO',
  'X-ABDATE',
  'X-ABRELATEDNAMES',
  'X-SOCIALPROFILE',
  'IMPP',
  'NOTE',
]);

const propertyOf = (line: string): string => {
  const head = line.split(':')[0] ?? '';
  const name = head.split(';')[0] ?? '';
  // Apple groups its properties as `item1.ADR`.
  return (name.split('.').pop() ?? name).trim().toUpperCase();
};

export function stripVcard(text: string): string {
  const lines = text.split(/\r\n|\n|\r/);
  const kept: string[] = [];
  let dropping = false;

  let softBreak = false;

  for (const line of lines) {
    const isFolded = line.startsWith(' ') || line.startsWith('\t');

    // Two continuation forms: RFC 6350 folds with leading whitespace, while
    // quoted-printable ends the previous line with `=` and continues at column
    // one. Missing the second would leave the tail of a dropped ADR behind as a
    // line of its own.
    if (isFolded || softBreak) {
      if (!dropping) kept.push(line);
      softBreak = line.endsWith('=');
      continue;
    }

    dropping = DROP.has(propertyOf(line));
    softBreak = line.endsWith('=');
    if (!dropping) kept.push(line);
  }

  return kept.join('\n');
}
